module.exports = "/images/service_thumb.png?c4520a60d24988ead0c2482d4fc86512";